// extracted by mini-css-extract-plugin
module.exports = {"container":"NavWidget_container__1Lhmm","content":"NavWidget_content__16X-M","icon":"NavWidget_icon__34q8x"};